angular.module('common.directives.appLoadingAnimation', [])

    .directive("appLoadingAnimation",function ($animate, $timeout) {
        // Return the directive configuration.
        return ({
            link: link,
            restrict: "C"
        });

        // I bind the JavaScript events to the scope.
        function link(scope, element, attributes) {

            // Due to the way AngularJS prevents animation during the bootstrap
            // of the application, we can't animate the top-level container; but,
            // since we added "ngAnimateChildren", we can animate the inner
            // container during this phase.
            // --
            // NOTE: Am using .eq(1) so that we don't animate the Style block.

            //That callback must be run when app is loaded.
            //This function must be called from any place where we could end up after loading screen.
            //In most often cases it will be a 'resolve' function of the view we end up in.
            window.omHideLoadingScreenCallback = function() {
                $animate.leave(element.children().eq(1)).then(
                    function cleanupAfterAnimation() {

                        // Remove the root directive element.
                        //element.remove();

                        // Clear the closed-over variable references.
                        //scope = element = attributes = null;

                    }
                );
            };
            //$timeout(, 700);
        }

    }
);